import React from "react";

export default function CheckboxField({
  label,
  checked,
  onChange,
  disabled = false,
  className = "",
}) {
  return (
    <label
      className={[
        "flex items-center gap-2 text-sm text-palette-gray-primary",
        disabled ? "opacity-60 cursor-not-allowed" : "",
        className,
      ].join(" ")}
    >
      <input
        type="checkbox"
        disabled={disabled}
        checked={!!checked}
        onChange={(e) => onChange?.(e.target.checked)}
        className="h-4 w-4 rounded border-palette-gray-border"
      />
      {label}
    </label>
  );
}
